import { useQuery } from 'react-query';
import { QUERY_KEY_ARTICLES, apiGetArticles } from './apiGetArticles';
import { useThisLang } from 'ui/LangUse';
import { useProContext } from 'store/ProReducer/useProContext';

export const useGetArticles = (params = {}, options = {}) => {
  const locale = useThisLang();
  const { modulId } = useProContext();

  return useQuery({
    queryKey: [QUERY_KEY_ARTICLES, params, locale],
    queryFn: () => apiGetArticles(params, locale, modulId),
    ...options,
  });
};
